import { defineStore } from 'pinia'
import { GalleryItem, GalleryCollection } from '@/store/gallery/types'
import * as seratoMediaStock from '@/serato-media-stock'
import { seratoMediaItemToGalleryItem, seratoCollectionToGalleryCollection, collectionNameSorter } from '@/utils/gallery-helper'
export interface StickerGalleryState {
  items: GalleryItem[],
  collections: GalleryCollection[],
  page: number
  totalResultItems: number
  itemsPerPage: number
  searchPhrase: string | null,
  selectedCollection: GalleryCollection | null
}

const collectionsOrder = [
  'Emoji',
  'Playful',
  'Serato',
  'Retro',
  'Trippy'
]

export const useStickerGalleryStore = defineStore('stickerGalleryStore', {
  state: (): StickerGalleryState => ({
    items: [],
    collections: [],
    page: 1,
    totalResultItems: 0,
    itemsPerPage: 15,
    searchPhrase: null,
    selectedCollection: null
  }),
  actions: {
    async clearItems (): Promise<void> {
      // this needs to be inside an async/await function because it triggers nextTick for watch to pick up the changes.
      this.items = []
    },
    async fetchByCollection (collection: GalleryCollection, page = 1): Promise<void> {
      this.selectedCollection = collection
      if (page === 1) {
        await this.clearItems()
      }
      switch (collection.source) {
      case 'serato': {
        const response = seratoMediaStock.fetchStickersByCollectionId(collection.id, page, this.itemsPerPage)
        const items = response.pageItems.map((mediaItem) => {
          return seratoMediaItemToGalleryItem(mediaItem)
        })
        this.items.push(...items)
        this.totalResultItems = response.totalResults
        break
      }
      }
      this.page = page
      this.searchPhrase = null
    },
    async fetchCollections (): Promise<void> {
      this.collections = []
      // Fetching Serato media stock collections
      seratoMediaStock.fetchStickerCollections().forEach(collection => {
        this.collections.push(seratoCollectionToGalleryCollection(collection))
      })
      this.collections.sort(collectionNameSorter(collectionsOrder))
    },
    async nextPage (): Promise<void> {
      const pages = Math.ceil(this.totalResultItems / this.itemsPerPage)

      if (this.page < pages) {
        if (this.selectedCollection) {
          await this.fetchByCollection(this.selectedCollection, ++this.page)
        }
      }
    }
  }
})
